import { createGlobalStyle } from 'styled-components/macro'

export default createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    html {
        position: relative;
    }

    body {
        font-size: 16px;
    }

    h1, 
    h2, 
    h3, 
    h4, 
    h5
    {
        font-family: 'Montserrat', sans-serif;
        line-height: 1.4;
    }

    a, 
    p,
    li, 
    span, 
    label, 
    small,
    input, 
    select, 
    textarea, 
    button,
    td,
    th  {
        font-family: 'Lato', sans-serif;
        line-height: 1.4;
    }

    button {
        margin: 0;
        padding: 0;
        -webkit-appearance: none;
        border: none;
        cursor: pointer;
        overflow: hidden;
        font-size: 1rem;
    }

    input {
        -webkit-appearance: none;
        border: none;
        background: none;
    }

    h1 {
        width: 100%;
        font-size: 2.5rem;
        font-weight: 500; 
    }

    h2 {
        width: 100%;
        font-size: 2.3rem;
    }

    h3 {
        width: 100%;
        font-size: 1.9rem;
        font-weight: 700;
    }

    p, span, label, small {
        line-height: 1.4;
    }

    strong {
        font-weight: 700;
    }

    img {
        width: 100%;
        max-width: 100%;
    }

    .z-20 {
        z-index: 20;
    }
`
